import { INITIAL_CUSTOMER_ENQUIRY_COL_DEF, INITIAL_CUSTOMER_ENQUIRY_COL_DEF_FOR_SAPT } from "presentation/constant/CustomerEnquiry/CustomerEnquiryColumnDefinition";
import { useCustomerEnquiryVM } from "presentation/hook/CustomerEnquiry/useCustomerEnquiryVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCustomerEnquiryTracked } from "presentation/store/CustomerEnquiry/CustomerEnquiryProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef } from "react";
const CustomerEnquiryTablePanel = () => {
    const gridRef: any = useRef(null);
    const [customerEnquiryState] = useCustomerEnquiryTracked();
    const { customerEnquiryList } = customerEnquiryState;
    const customerEnquiryVM = useCustomerEnquiryVM();
    const [anainfoState] = useANAInfoTracked();
    const { operatingUnit } = anainfoState;

    // const memoTableSearchBtn = useMemo(() => {
    //     const searchBtn = [];

    //     searchBtn.push({
    //         id: 'onSearchButton',
    //         icon: 'Icon-search',
    //         title: 'Search'
    //     })
    //     return searchBtn
    // }, []);

    const handleSearch = useCallback(async () => {
        customerEnquiryVM.onSearchClick();
    }, [customerEnquiryVM]);

    const memoCustomerEnquiryTable = useMemo(() => {

        return (
            <NbisTable
                id='customer-enquiry-table'
                // headerActionButtons={memoTableSearchBtn}
                isNewColumnSetting={true}
                columns={(operatingUnit === 'SAPT' || operatingUnit === 'KICT') ? INITIAL_CUSTOMER_ENQUIRY_COL_DEF_FOR_SAPT : INITIAL_CUSTOMER_ENQUIRY_COL_DEF}
                data={customerEnquiryList ?? []}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                isRowHighligted={true}
                gridHeight="customHeight"
                customHeight="calc(100vh - 125px)"
                ref={gridRef}
                onSearchButton={handleSearch}
            />
        );
    }, [customerEnquiryList, handleSearch, operatingUnit])

    return <><TableWrapper>
        {memoCustomerEnquiryTable}
    </TableWrapper>
    </>;
}

export default memo(CustomerEnquiryTablePanel);
